var _g, _path, _g2, _path2, _g3, _path3, _g4, _path4, _g5, _path5, _g6, _path6, _g7, _path7, _g8, _path8, _g9, _path9, _g10, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTailoredRiskPercent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "556.438px",
    height: "127.876px",
    viewBox: "256.515 319.042 556.438 127.876",
    enableBackground: "new 256.515 319.042 556.438 127.876",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 462.667,
    y: 319.042,
    width: 21.333,
    height: 20.958
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.38,339.958c5.797-0.016,10.469-4.677,10.459-10.422c0.01-5.75-4.662-10.412-10.459-10.427 c-5.734,0.016-10.411,4.677-10.396,10.427C462.969,335.281,467.646,339.943,473.38,339.958"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471.875,405.989V442c-0.005,6.552-9.849,6.552-9.828,0v-35.761h-13.276l14.151-48.932h-2.192l-8.203,27.583 c-1.964,6.031-10.25,3.557-8.328-2.87l9.083-29.958c1-3.422,5.333-9.479,12.833-9.484h14.344c7.459,0.005,11.813,6.115,12.959,9.484 l9.083,29.896c1.854,6.458-6.364,9.125-8.328,2.87l-8.203-27.521h-2.38l14.213,48.932h-13.213v35.823c0,6.489-9.803,6.458-9.828,0 v-36.073H471.875"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 524,
    y: 319.042,
    width: 22.667,
    height: 20.958
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_4_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.417,339.958c5.797-0.016,10.469-4.677,10.458-10.422c0.011-5.75-4.661-10.412-10.458-10.427 c-5.734,0.016-10.412,4.677-10.396,10.427C525.005,335.281,529.683,339.943,535.417,339.958"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M533.917,405.989V442c-0.011,6.552-9.854,6.552-9.834,0v-35.761h-13.275l14.15-48.932h-2.188l-8.203,27.583 c-1.969,6.031-10.255,3.557-8.328-2.87l9.078-29.958c1-3.422,5.334-9.479,12.834-9.484h14.344 c7.458,0.005,11.813,6.115,12.958,9.484l9.083,29.896c1.854,6.458-6.364,9.125-8.328,2.87l-8.203-27.521h-2.38l14.214,48.932 h-13.214v35.823c0,6.489-9.802,6.458-9.828,0v-36.073H533.917"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 586.667,
    y: 319.042,
    width: 21.333,
    height: 20.958
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_6_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597.453,339.958c5.797-0.016,10.469-4.677,10.458-10.422c0.011-5.75-4.661-10.412-10.458-10.427 c-5.734,0.016-10.411,4.677-10.396,10.427C587.042,335.281,591.719,339.943,597.453,339.958"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M595.953,405.989V442c-0.011,6.552-9.854,6.552-9.833,0v-35.761h-13.276l14.151-48.932h-2.188l-8.203,27.583 c-1.969,6.031-10.256,3.557-8.328-2.87l9.078-29.958c1-3.422,5.333-9.479,12.833-9.484h14.344 c7.458,0.005,11.813,6.115,12.958,9.484l9.084,29.896c1.854,6.458-6.365,9.125-8.328,2.87l-8.203-27.521h-2.381l14.214,48.932 h-13.214v35.823c0,6.489-9.802,6.458-9.828,0v-36.073H595.953"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 648,
    y: 319.042,
    width: 22.667,
    height: 20.958
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_8_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M659.489,339.958c5.797-0.016,10.469-4.677,10.459-10.422c0.01-5.75-4.662-10.412-10.459-10.427 c-5.734,0.016-10.411,4.677-10.396,10.427C649.078,335.281,653.755,339.943,659.489,339.958"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M657.989,405.989V442c-0.01,6.552-9.854,6.552-9.833,0v-35.761H634.88l14.151-48.932h-2.188l-8.203,27.583 c-1.969,6.031-10.255,3.557-8.328-2.87l9.078-29.958c1-3.422,5.333-9.479,12.839-9.484h14.338 c7.459,0.005,11.813,6.115,12.959,9.484l9.083,29.896c1.854,6.458-6.364,9.125-8.328,2.87l-8.203-27.521h-2.38l14.213,48.932 h-13.213v35.823c0,6.489-9.803,6.458-9.828,0v-36.073H657.989"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 710.667,
    y: 319.042,
    width: 21.333,
    height: 20.958
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_10_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.526,339.958c5.797-0.016,10.469-4.677,10.458-10.422c0.011-5.75-4.661-10.412-10.458-10.427 c-5.734,0.016-10.412,4.677-10.396,10.427C711.114,335.281,715.792,339.943,721.526,339.958"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M720.026,405.989V442c-0.011,6.552-9.854,6.552-9.834,0v-35.761h-13.275l14.15-48.932h-2.188l-8.203,27.583 c-1.969,6.031-10.255,3.557-8.328-2.87l9.078-29.958c1-3.422,5.334-9.479,12.839-9.484h14.339 c7.458,0.005,11.813,6.115,12.958,9.484l9.083,29.896c1.854,6.458-6.364,9.125-8.328,2.87l-8.203-27.521h-2.38l14.214,48.932 h-13.214v35.823c0,6.489-9.802,6.458-9.828,0v-36.073H720.026"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 772,
    y: 319.042,
    width: 22.667,
    height: 20.958
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_12_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M783.563,339.958c5.797-0.016,10.469-4.677,10.458-10.422c0.011-5.75-4.661-10.412-10.458-10.427 c-5.734,0.016-10.411,4.677-10.396,10.427C773.151,335.281,777.828,339.943,783.563,339.958"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M782.063,405.989V442c-0.011,6.552-9.854,6.552-9.833,0v-35.761h-13.276l14.151-48.932h-2.188l-8.203,27.583 c-1.969,6.031-10.256,3.557-8.328-2.87l9.078-29.958c1-3.422,5.333-9.479,12.838-9.484h14.339 c7.458,0.005,11.813,6.115,12.958,9.484l9.084,29.896c1.854,6.458-6.365,9.125-8.328,2.87l-8.203-27.521h-2.381l14.214,48.932 h-13.214v35.823c0,6.489-9.802,6.458-9.828,0v-36.073H782.063"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 274.667,
    y: 319.042,
    width: 22.667,
    height: 20.958
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_14_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9705A",
    d: "M285.979,339.958c5.797-0.016,10.474-4.677,10.458-10.422c0.016-5.75-4.662-10.412-10.458-10.427 c-5.734,0.016-10.411,4.677-10.391,10.427C275.568,335.281,280.245,339.943,285.979,339.958"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9705A",
    d: "M284.479,405.989V442c-0.01,6.552-9.854,6.552-9.833,0v-35.761h-13.271l14.151-48.932h-2.192l-8.203,27.583 c-1.969,6.031-10.25,3.557-8.328-2.87l9.078-29.958c1-3.422,5.333-9.479,12.838-9.484h14.338c7.458,0.005,11.813,6.115,12.963,9.484 l9.078,29.896c1.854,6.458-6.364,9.125-8.328,2.87l-8.203-27.521h-2.38l14.214,48.932h-13.208v35.823c0,6.489-9.808,6.458-9.833,0 v-36.073H284.479"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 337.333,
    y: 319.042,
    width: 21.334,
    height: 20.958
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_16_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9705A",
    d: "M347.771,339.958c5.792-0.016,10.469-4.677,10.453-10.422c0.016-5.75-4.661-10.412-10.453-10.427 c-5.739,0.016-10.411,4.677-10.396,10.427C337.359,335.281,342.031,339.943,347.771,339.958"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9705A",
    d: "M346.266,405.989V442c-0.005,6.552-9.854,6.552-9.828,0v-35.761h-13.276l14.151-48.932h-2.192l-8.203,27.583 c-1.969,6.031-10.25,3.557-8.328-2.87l9.078-29.958c1-3.422,5.333-9.479,12.838-9.484h14.339c7.458,0.005,11.813,6.115,12.964,9.484 l9.078,29.896c1.854,6.458-6.365,9.125-8.328,2.87l-8.203-27.521h-2.381l14.214,48.932h-13.208v35.823c0,6.489-9.808,6.458-9.834,0 v-36.073H346.266"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_17_",
    x: 400,
    y: 319.042,
    width: 22.667,
    height: 20.958
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SVGID_18_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9705A",
    d: "M411.344,339.958c5.797-0.016,10.469-4.677,10.458-10.422c0.011-5.75-4.661-10.412-10.458-10.427 c-5.734,0.016-10.411,4.677-10.396,10.427C400.933,335.281,405.609,339.943,411.344,339.958"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9705A",
    d: "M409.839,405.989V442c-0.006,6.552-9.85,6.552-9.828,0v-35.761h-13.276l14.151-48.932h-2.193l-8.203,27.583 c-1.963,6.031-10.25,3.557-8.328-2.87l9.084-29.958c1-3.422,5.333-9.479,12.833-9.484h14.344c7.458,0.005,11.813,6.115,12.958,9.484 l9.084,29.896c1.854,6.458-6.365,9.125-8.328,2.87l-8.203-27.521h-2.381l14.214,48.932h-13.214v35.823c0,6.489-9.802,6.458-9.828,0 v-36.073H409.839"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.355954, 22.696074)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.823371, 22.696074)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(211.759696, 22.696074)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailoredRiskPercent);
export default __webpack_public_path__ + "static/media/tailored_risk_percent.9aec83f75e97fc8fd643fce0f19b10c2.svg";
export { ForwardRef as ReactComponent };